module.exports = __webpack_public_path__ + "files/c6e2373969926b784268c4c5590fa965.png";